import styled from 'styled-components'
import ParentStyles from '../../styles'

const Container = styled.div`
  display: flex;
  padding: 16px 16px 16px 32px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 1;
  border-bottom: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));
  background: ${props => props.backgroundColor};
  position: relative;

  &:before {
    width: 8px;
    height: 100%;
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    background: ${props => props.color};
  }
`

const Badge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  gap: 6px;
  border-radius: 4px;
  border: 1px solid #d3d3d3;
  background: #f3f3f3;
  color: #898989;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 83.333%;
  text-transform: capitalize;
`

const SazonalDatesBadge = styled(Badge)`
  border: 1px solid #ffd4bd;
  background: #ffeade;
  color: #c27123;
`

const GeneralAlertsBadge = styled(Badge)`
  border: 1px solid #a600ff;
  background: #f7eaff;
  color: #a600ff;
`

const Title = styled.h3`
  color: #2f2b3d;
  opacity: 0.9;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
`

const Description = styled.span`
  color: #2f2b3d;
  opacity: 0.7;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  strong {
    font-weight: 700;
  }
`

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  white-space: break-spaces;
`

const Styles = {
  Container,
  GeneralAlertsBadge,
  SazonalDatesBadge,
  IgnoreButton: ParentStyles.OutlineButton,
  SazonalDatesButton: ParentStyles.SuccessButton,
  GeneralAlertsButton: ParentStyles.BlackButton,
  Title,
  Description,
  ButtonsWrapper,
  ContentWrapper,
  TextWrapper,
}

export default Styles
